import { TimePeriodSelectOption } from './time-period-picker.models';

export const LOCAL_STORAGE_TIME_PERIOD_KEY: string = 'period';

export const TIME_PERIOD_PICKER_OPTIONS: ReadonlyArray<TimePeriodSelectOption> =
  [
    {
      label: 'CENTER.TIME_PICKER.OPTION_1',
      value: 'last24h',
    },
    {
      label: 'CENTER.TIME_PICKER.OPTION_2',
      value: 'lastDay',
    },
    {
      label: 'CENTER.TIME_PICKER.OPTION_3',
      value: 'lastWeek',
    },
    {
      label: 'CENTER.TIME_PICKER.OPTION_4',
      value: 'lastMonth',
    },
    {
      label: 'CENTER.TIME_PICKER.OPTION_5',
      value: 'lastYear',
    },
    {
      label: 'CENTER.TIME_PICKER.OPTION_6',
      value: 'customDate',
    },
  ];

export const TIME_PERIOD_VALUES = TIME_PERIOD_PICKER_OPTIONS.map(
  (option) => option.value,
);
